module.exports = __webpack_public_path__ + "static/media/author-3.d26bb9af.png";